import * as React from 'react';
export const IcAerobics = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M12 5a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm7 1H5a1 1 0 000 2h6v5.07a6.32 6.32 0 00-3.8 1.75A8.49 8.49 0 005 21a1 1 0 102 0 6.66 6.66 0 011.61-4.76 4.3 4.3 0 012.5-1.17c.74 3.89 5.31 5.77 5.52 5.86a1 1 0 10.74-1.86S13 17.29 13 14V8h6a1 1 0 100-2z'
      fill='currentColor'
    />
  </svg>
);
